module.exports = __webpack_public_path__ + "img/20210619_171725.270291ba.jpg";